import { useAuth } from 'react-oidc-context';
import { z } from 'zod';

const UserProfileSchema = z.object({
  email: z.string(),
  family_name: z.string(),
  given_name: z.string(),
  user_id: z.string(),
  sub: z.string(),
  typesense: z.string().nullish(),
});

export interface UserProfile {
  firstName: string;
  lastName: string;
  email: string;
  userId: string;
  keycloakId: string;
  typesenseApiKey: string;
}

export const useCurrentUser = (): UserProfile => {
  const { user } = useAuth();
  const profile = UserProfileSchema.parse(user?.profile);

  return {
    firstName: profile.given_name,
    lastName: profile.family_name,
    email: profile.email,
    userId: profile.user_id,
    keycloakId: profile.sub,
    typesenseApiKey: profile.typesense ?? '',
  };
};
